export const DataConf = {
  initialState: {
    loading: false,
    error: null,
    data: [],
    meta: null,
  },
};



export const HeadProductsInLogbookEditable = [
  {
    width: 40,
    label: '',
    dataKey: 'collapse',
    sortable: false,
  },
  {
    id: 'SUPPLIER',
    label: 'SUPPLIER',
    key: 'attributes.id_logbook.data.attributes.id_supplier.data.attributes.label',
    sortable: true,
    width: 300,
  },
  {
    id: 'STATUS',
    label: 'STATUS',
    key: 'attributes.id_logbook.data.attributes.status_logbook',
    sortable: true,
    width: 200,
  },

  {
    label: '',
    dataKey: 'logbook',
    sortable: false,
    width: '3%',
  },
];

export const HeaderProductsInCollapse = [
  {
    width: 50,
    label: '',
    dataKey: 'checkbox',
    sortable: false,
    checkbox: true,
    selectable: true,
  },
  {
    id: 'PRODUCT',
    label: 'PRODUCT',
    sortable: true,
    key: 'attributes.id_item.data.attributes.name_ITA',
  },
  {
    id: 'PHOTO',
    label: 'PHOTO',
    key: 'attributes.photo',
    width: 150,
  },
  {
    id: 'QUANTITY',
    label: 'QUANTITY',
    key: 'attributes.quantity',
    sortable: true,
    width: 280,
  },

  {
    id: 'AVAILABLE',
    label: 'AVAILABLE',
    key: 'attributes.available',
    sortable: true,
    width: 220,
  },
  {
    id: 'STOCK',
    label: 'STOCK',
    key: 'attributes.stock_available',
    sortable: true,
  },
  {
    width: 140,
    label: '',
    dataKey: 'crud',
    sortable: false,
  },
];

export const columnsProducts = [
  {
    width: 50,
    label: '',
    dataKey: 'checkbox',
    sortable: false,
    checkbox: true,
    selectable: true,
  },
  {
    label: 'PRODUCT',
    dataKey: 'name',
    key: 'attributes.id_item.data.attributes.name_ITA',
    sortable: true,
  },
  {
    label: 'Photo',
    dataKey: 'photo',
    key: 'attributes.photo',
    sortable: false,
    width: 200,
  },
  {
    width: 200,
    label: 'Quantity',
    dataKey: 'quantity',
    key: 'attributes.quantity',
    sortable: true,
  },
  {
    width: 50,
    label: '',
    dataKey: 'crud',
    sortable: false,
  },
];

export const columnsLogbook = [
  {
    width: 40,
    label: '',
    dataKey: 'collapse',
    sortable: false,
  },
  {
    id: 'SUPPLIER',
    label: 'SUPPLIER',
    key: 'attributes.id_logbook.data.attributes.id_supplier.data.attributes.label',
    sortable: true,
    width: 300,
  },
  {
    id: 'STATUS',
    label: 'STATUS',
    key: 'attributes.id_logbook.data.attributes.status_logbook',
    sortable: true,
    width: 200,
  },

  {
    label: '',
    dataKey: 'logbook',
    sortable: false,
    width: '3%',
  },
];
